// import 'core-js/fn/array/find';
// import 'core-js/fn/array/find-index';
// import 'core-js/fn/array/includes';
// import 'core-js/fn/array/from';
// import 'core-js/fn/object/assign';
// import 'core-js/fn/object/set-prototype-of';
// import 'core-js/fn/object/get-prototype-of';
// import 'core-js/fn/object/values';
// import 'core-js/fn/string/starts-with';
// import 'core-js/fn/string/includes';
// import 'core-js/fn/string/ends-with';
// import 'core-js/es6/symbol';
// import 'core-js/es6/promise';
// import 'core-js';
(function() {
  // проверяем поддержку
  if (!Element.prototype.matches) {
    // определяем свойство
    Element.prototype.matches =
      Element.prototype.matchesSelector ||
      Element.prototype.webkitMatchesSelector ||
      Element.prototype.mozMatchesSelector ||
      Element.prototype.msMatchesSelector;
  }
}());

(function() {
  // проверяем поддержку
  if (!Element.prototype.closest) {
    // реализуем
    Element.prototype.closest = function(css) {
      let node = this;

      while (node) {
        if (node.matches(css)) return node;
        else node = node.parentElement;
      }
      return null;
    };
  }
}());

(function() {
  // проверяем поддержку
  if (!HTMLCanvasElement.prototype.toBlob) {
    Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
      value: function(callback, type, quality) {
        const canvas = this;
        setTimeout(function() {
          const binStr = atob(canvas.toDataURL(type, quality).split(',')[1]);
          const len = binStr.length;
          const arr = new Uint8Array(len);

          for (let i = 0; i < len; i++) {
            arr[i] = binStr.charCodeAt(i);
          }

          callback(new Blob([arr], { type: type || 'image/png' }));
        });
      }
    });
  }
}());



// WEBPACK FOOTER //
// ./src/util/polyfill.js